<ul class="pending-order-list">
  <li class="pending-order-card" *ngFor="let order of orders">
    <div class="pending-order-card__body">
      <div class="pending-order-card__main">
        <span class="pending-order-card__badge">
          <span
            class="pending-order-card__badge-icon mdn-Icon-circulo-exclamacao mdn-Icon--sm"
            aria-hidden="true"
          ></span>
          {{ 'components.pendingOrderPanel.flag' | i18n }}
        </span>

        <h2 class="pending-order-card__product">{{ order.productName }}</h2>

        <p class="pending-order-card__meta">
          <span>{{ order.quantity }} {{ getQuantityLabel(order.quantity) | i18n }}</span>
          <span class="pending-order-card__meta-sep" aria-hidden="true">·</span>
          <span>{{ formatDate(order.orderDate) }}</span>
        </p>
      </div>

      <div class="pending-order-card__action">
        <ustore-button
          [text]="'components.pendingOrderPanel.completeData' | i18n"
          [format]="'filled'"
          [backgroundColor]="
            order.token ? 'var(--color-red-500-to-yellow)' : undefined
          "
          [textColor]="order.token ? 'var(--color-inverted)' : undefined"
          [size]="'medium'"
          [rounded]="'rounded'"
          [disabled]="!order.token"
          (onClick)="onCompleteDataClick(order.token)"
        ></ustore-button>
      </div>
    </div>
  </li>
</ul>
